import styled from 'styled-components';
import { FlexColumn } from '@make-software/tg-mini-app-ui';

import Bg from '@/shared/assets/backgrounds/bg-main.png';

export const CONTAINER_HEIGHT = '100vh';
export const FOOTER_BOTTOM_SAFE_AREA_PADDING = 'env(safe-area-inset-bottom, 0px)';

export const Container = styled(FlexColumn)(({ theme }) =>
  theme.withMedia({
    backgroundColor: theme.colors.cardBg,
    color: theme.colors.contentPrimary,
    height: CONTAINER_HEIGHT,
    width: '100%',
    justifyContent: 'space-between',
    '@media only screen and (min-width: 768px)': {
      width: '640px',
      overflow: 'auto'
    },
    '@media only screen and (min-width: 480px) and (max-width: 768px)': {
      width: '100%'
    }
  })
);

export const Content = styled.div(({ theme }) =>
  theme.withMedia({
    backgroundColor: theme.colors.cardBg,
    backgroundImage: `url(${Bg})`,
    flex: '1 1 0',
    overflowY: 'auto',
    paddingTop: '20px',
    minHeight: '0' /* IMPORTANT: allows flexbox to shrink it so it can scroll */
  })
);

export const FooterContainer = styled.div(({ theme }) =>
  theme.withMedia({
    backgroundColor: theme.colors.cardBg,
    bottom: 0,
    flexShrink: 0,
    paddingBottom: FOOTER_BOTTOM_SAFE_AREA_PADDING,
    position: 'sticky',
    zIndex: 10
  })
);
